import { removeNullElements } from "../commons"

export default (messages, indexes) => {
    const { from, to } = indexes
    
    const fromMessage = messages[from]
    messages = messages.map((message, i) => {
      if (i === from) {
        return null
      }
      return message
    })

    if (to === 0 ) {
      return removeNullElements([fromMessage].concat(messages)) 
    }

    let updatedMessages = [] 
    messages.map((message, i) => {
      updatedMessages.push(message)  
      if (i+1 === to ) {
        updatedMessages.push(fromMessage)
      }
    }) 

    updatedMessages = removeNullElements(updatedMessages)
    return updatedMessages
}